import React from 'react';
import { useTranslation } from 'react-i18next';
import Logo from './Logo';
import ContactUs from './ContactUs';
import { services } from '../pages/ServicesPage';

const Footer: React.FC = () => {
  const { t } = useTranslation();

  const socialMedia = [
    {
      name: 'facebook',
      icon: 'fab fa-facebook-f',
      url: 'https://www.facebook.com/share/176dCtJkDc/?mibextid=wwXIfr',
    },
    {
      name: 'instagram',
      icon: 'fab fa-instagram',
      url: 'https://www.instagram.com/oneseventeentravels?igsh=dXhlbXUzcmEyNW10',
    },
    {
      name: 'snapchat',
      icon: 'fab fa-snapchat-ghost',
      url: 'https://www.snapchat.com/add/oneseventeen117?share_id=PUEXZ8ek3Ts&locale=en-AE',
    },
    {
      name: 'tiktok',
      icon: 'fab fa-tiktok',
      url: 'https://www.tiktok.com/@oneseventeentravels?_t=ZS-8yxCGM7QQul&_r=1',
    },
  ];

  return (
    <footer
      className="py-6 px-6 md:px-12 z-50"
      style={{ backgroundColor: '#0a0a0a' }}
    >
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Column 1: Logo and Social Media */}
          <div>
            <Logo
              size="md"
              className="mb-4"
            />
            <p className="text-gray-400 mb-4">{t('footer.description')}</p>
            <div className="flex">
              {socialMedia.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white w-10 h-10 rounded-full flex items-center justify-center bg-gray-800 hover:bg-blue-500 transition-colors duration-300 shadow-lg mr-2 first:mr-0"
                  aria-label={social.name}
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Our Services */}
          <div>
            <h3 className="text-white font-bold mb-4">
              {t('footer.services')}
            </h3>
            <ul className="text-gray-400 space-y-2">
              {services.map((service) => (
                <li
                  key={service.id}
                  className="flex items-center"
                >
                  <i className={`${service.icon} text-blue-600 mr-2`}></i>
                  <p className="mr-2">{t(service.title)}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Address and Contact Info (reusable) */}
          <div className="text-gray-400">
            <h3 className="text-white font-bold mb-4">{t('footer.contact')}</h3>
            <ContactUs
              compact
              hideTitle
            />
          </div>
        </div>

        <div className="border-t border-gray-800 mt-6 pt-4 text-center text-gray-500">
          <p>
            &copy; {new Date().getFullYear()} {t('footer.copyright')}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
